var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #da251d;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #292c6c;\n      }\n\n      .cls-3 {\n        fill: #6175af;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.6.1l7.5,2.7c.3,0,.4.3.4.6s-.2.5-.4.6l-7.5,2.7c-.2,0-.4.1-.6.1s-.4,0-.6-.1l-4.5-1.6c.3-.3.7-.5,1.1-.6l4.3-1.6c.2,0,.3-.3.3-.6,0-.2-.3-.3-.6-.3l-4.3,1.6c-.6.2-1.2.6-1.7,1.1l-2.1-.7c-.3,0-.4-.3-.4-.6s.2-.5.4-.6L8.4.1c.2,0,.4-.1.6-.1s.4,0,.6.1ZM4.3,6.2l3.8,1.4c.3.1.6.2.9.2s.6,0,.9-.2l3.8-1.4.4,3.9c0,.9-2.3,1.9-5.1,1.9s-5.1-1-5.1-1.9l.4-3.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.7,7.7s0,0,0,0c0-1.8,1.2-3.4,2.9-4l4.3-1.6c.2,0,.5,0,.6.3,0,.2,0,.5-.3.6h0s-4.3,1.6-4.3,1.6c-1.3.5-2.2,1.7-2.3,3.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.6,7.6c.2.4.3.7.4,1.1.2.7.3,1.8,0,2.9,0,.1,0,.2-.2.3,0,0-.2,0-.3,0l-1.7-.4c-.1,0-.3-.1-.3-.3,0-.1,0-.3,0-.4.2-.3.4-.7.6-1,.3-.6.6-1.4.6-2.2s0,0,0,0h.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodleActive);
export default __webpack_public_path__ + "static/media/moodle-active.002f6ff3ffd2f530eaafafc27e3b1fed.svg";
export { ForwardRef as ReactComponent };